// oxlint-disable-next-line typescript/triple-slash-reference -- an ambient wildcard module can't be imported.
/// <reference path="./inline-css.d.ts" />
/** The library's styles, scoped under `.sc-view` so they look the same on softmax.com and on another site. */
import TOKENS from './styles/tokens.css?inline'
import UI from './base/ui.css?inline'
import MARKDOWN from './base/markdown.css?inline'
import CHART from './chart/chart.css?inline'
import COMPONENTS from './components/components.css?inline'

const KEYFRAMES = /@keyframes[^{]+\{(?:[^{}]*\{[^{}]*\})*[^{}]*\}/g

const OWN = `
.sc-view-title { font-weight: 600; }
[data-chosen]::before { content: "✓" / ""; font-weight: 600; margin-right: 6px; }
.btn[data-chosen] { background: none; border-color: var(--ink); color: var(--ink); opacity: 1; }
/* A view sits in a chat, so it fits the room it has rather than the window's. */
@container (max-width: 420px) {
  .row { column-gap: 12px; grid-template-columns: minmax(0, 1fr) auto; padding: 8px 12px; row-gap: 2px; }
  .row-name { grid-column: 1; }
  .row-detail { grid-column: 1; grid-row: 2; overflow: hidden; text-overflow: ellipsis; }
  .row-time { grid-column: 2; grid-row: 1 / span 2; }
}
.sc-custom { display: flex; flex-direction: column; gap: 4px; margin: 0; }
.sc-custom-frame { background: transparent; border: 1px solid var(--line); border-radius: var(--radius-control); pointer-events: none; width: 100%; }
.sc-custom-note { color: var(--ink-3); font-size: var(--text-meta); }
`

const rules = UI + MARKDOWN + CHART + COMPONENTS + OWN

export const COGENT_VIEW_CSS = `${TOKENS.replace(':root', '.sc-view')}
${rules.match(KEYFRAMES)?.join('\n') ?? ''}
.sc-view {
  color: var(--ink);
  container-type: inline-size;
  display: flex;
  flex-direction: column;
  font: 400 var(--text-body) / 1.45 var(--font-sans);
  gap: 10px;
  min-width: 0;
  width: 100%;
  & * { box-sizing: border-box; }
  ${rules.replace(KEYFRAMES, '')}
}`

const STYLE_ID = 'softmax-cogent-view-styles'

/** Adds the view styles once to a document or shadow root. */
export function installViewStyles(root: Document | ShadowRoot = document) {
  const parent = root instanceof Document ? root.head : root

  if (parent.querySelector(`#${STYLE_ID}`)) return

  const style = document.createElement('style')
  style.id = STYLE_ID
  style.textContent = COGENT_VIEW_CSS
  parent.append(style)
}
